// @flow
import React from 'react'
import styled, { css, type StyledComponent } from 'styled-components'

export const PrimaryStyle = css`
  border: none;
  background-image: linear-gradient(to top, #1a89c1 0%, #2ab3d5 100%);
  color: #fff;
  border-radius: 5px;
  text-decoration: none;
  font-size: ${({ small }: Object) => (small ? '13' : '16')}px;
  height: ${({ height, small }: Object) => height || (small ? '30' : '40')}px;
  padding: 0 ${({ small }: Object) => (small ? '10' : '20')}px;
  line-height: ${({ height, small }: Object) => height || (small ? '32' : '40')}px;
  font-weight: 400;
  &:hover {
    background-image: linear-gradient(to top, #2ab3d5 0%, #2ab3d5 100%);
  }
  &:active {
    background-image: linear-gradient(to top, #2ab3d5 0%, #2ab3d5 100%);
    box-shadow: inset rgba(0, 0, 0, 0.3) 0 1px 3px 0;
  }
  &.disabled,
  &:disabled {
    color: rgba(255, 255, 255, 0.5);
    background: #a5a5a4;
    cursor: default;
    &:hover,
    &:active {
      color: rgba(255, 255, 255, 0.5);
      background: #a5a5a4;
      cursor: default;
      box-shadow: none;
    }
  }
  ${({ beforeContent, height, small }: Object) =>
    beforeContent
      ? `
      float: left;
      font-size: ${small ? '13' : '16'}px;
      &:before {
        content: '${beforeContent}';
        font-size: ${small ? '21' : '26'}px;
        display: inline-block;
        margin: 0 6px 0 0;
        vertical-align: top;
        line-height: ${height || (small ? '32' : '40')}px;
      }
      `
      : ''}
`

const Link: StyledComponent<Object, any, any> = styled.a`
  ${PrimaryStyle};
  display: inline-block;
`

const Button: StyledComponent<Object, any, any> = styled.button`
  ${PrimaryStyle};
`

type Props = {|
  children?: any,
  href?: string,
  small?: boolean,
  height?: number,
  disabled?: boolean,
  beforeContent?: string,
  className?: string,
  onClick?: Function,
  target?: string
|}

export default function PrimaryButton({ href, ...props }: Props) {
  return href ? <Link href={href} {...props} /> : <Button {...props} />
}
